/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { lazy, object, Schema, string } from '../schema';
import { Amount, amountSchema } from './amount';

export interface Balance1 {
  amount: Amount;
  creditDebitIndicator: string;
  type: string;
}

export const balance1Schema: Schema<Balance1> = object({
  amount: ['Amount', lazy(() => amountSchema)],
  creditDebitIndicator: ['CreditDebitIndicator', string()],
  type: ['Type', string()],
});
